// Informations de l'éditeur reprises dans les pages légales (mentions, confidentialité, conditions de vente),
// dans toutes les langues. À compléter par Léni avant la mise en ligne des pages : chaque valeur 'TODO' s'affiche
// en évidence (« TODO ») et la page porte un bandeau « brouillon » tant qu'il en reste une.
// Une valeur vide ('') masque la ligne qui l'utilise (champ facultatif ou sans objet).
// Rien ici n'a été deviné : seuls les faits connus du projet sont écrits dans les textes eux-mêmes.

export const LEGAL_INFO = {
  /** Prénom et nom du titulaire de l'entreprise individuelle (responsable du traitement). */
  owner: 'Léni Parmigiani',
  /** Raison de commerce de l'entreprise individuelle (en Suisse, elle contient le nom de famille du titulaire). */
  business: 'ParmigianiStudio',
  /** Adresse postale complète : rue et numéro, NPA, localité, Suisse. */
  address: 'Route de Moiry 21, CH-1313 Ferreyres',
  /** Adresse e-mail de contact, obligatoire (LCD art. 3) ; elle sert aussi au support et aux demandes sur les données. */
  email: 'cokacbb@gmail.com',
  /** Téléphone, facultatif en Suisse : '' pour ne pas l'afficher. */
  phone: '',
  /** Numéro IDE (CHE-…) si l'entreprise est inscrite au registre du commerce ; '' sinon. */
  uid: '',
  /** Numéro de TVA si l'entreprise est assujettie ; '' sinon (les prix affichés restent des prix finaux). */
  vat: '',
  /** Hébergeur : raison sociale, adresse et site (le serveur est un VPS netcup). */
  host: 'netcup GmbH, Emmy-Noether-Straße 10, D-76131 Karlsruhe, www.netcup.com',
  /** Pays du centre de données du serveur, en code ISO à deux lettres (ex. 'DE'), d'après le contrat netcup. */
  serverCountry: 'DE',
  /**
   * Représentant dans l'Union européenne (RGPD art. 27 : nom et adresse), à vérifier avec une personne compétente :
   * le jeu s'adresse aussi à des joueurs de l'UE. '' s'il n'est pas requis.
   */
  euRep: '',
  /** For : localité des tribunaux compétents (en principe celle du domicile de l'entreprise). */
  court: 'Ferreyres',
};

export type LegalField = keyof typeof LEGAL_INFO;

/** Date de la version des trois documents (à changer à chaque modification des textes). */
export const LEGAL_UPDATED = '2026-11-03';

export const isTodo = (v: string) => v.trim().toUpperCase().startsWith('TODO');

/** Champs encore à compléter (affichés en évidence sur les pages et listés par les tests). */
export function todoFields(): LegalField[] {
  return (Object.keys(LEGAL_INFO) as LegalField[]).filter((k) => isTodo(LEGAL_INFO[k]));
}
